import * as Yup from "yup"
import { TRANSLATION_INDEX_GLOBAL } from "../../config/translation"

export default Yup.object().shape({
  usuario: Yup.string().required(TRANSLATION_INDEX_GLOBAL.REQUIRED),
  clave: Yup.string().required(TRANSLATION_INDEX_GLOBAL.REQUIRED)
})
